import $ from "jquery";

export class Accordion {
	constructor(domNode) {
		console.debug("Accordion: inizializzazione", domNode);
		// Ignora se dentro .menu-accordion
		if (domNode.closest(".menu-accordion")) {
			return;
		}

		this.rootEl = domNode;

		this.buttonEl = this.rootEl?.querySelector("button[aria-expanded]");
		if (!this.buttonEl) {
			console.warn("Accordion: nessun <button aria-expanded> trovato in", this.rootEl);
			return;
		}

		const controlsId = this.buttonEl.getAttribute("aria-controls");
		if (!controlsId) {
			console.warn("Accordion: il bottone non ha aria-controls:", this.buttonEl);
			return;
		}

		this.contentEl = document.getElementById(controlsId);
		if (!this.contentEl) {
			console.warn(`Accordion: nessun elemento con id="${controlsId}" trovato nel documento.`);
			return;
		}

		this.open = false;
		this.multicollapse = this.buttonEl.getAttribute("data-multi-collapse") !== null;

		this.buttonEl.setAttribute("aria-expanded", "false");
		$(this.contentEl).slideUp(0); // Evita flicker all’avvio

		this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
	}

	onButtonClick() {
		if (!this.buttonEl || !this.contentEl) return;

		const isInsideOffcanvas = this.rootEl.closest('#offcanvas-login-content');

		if (isInsideOffcanvas) {
			$('#offcanvas-login-content .accordion button[aria-expanded="true"]').each((_, el) => {
				if (el === this.buttonEl) return;

				const $btn = $(el);
				const contentId = $btn.attr('aria-controls');
				if (!contentId) return;

				const contentEl = document.getElementById(contentId);
				if (!contentEl) return;

				$btn.attr('aria-expanded', 'false');
				$(contentEl).slideUp();
				$btn.parentElement?.classList.remove('accordion-expanded'); // 👉 rimuove la classe dal padre
			});
		}

		// Toggle normale
		this.open = this.buttonEl.getAttribute("aria-expanded") !== "true";
		this.buttonEl.setAttribute("aria-expanded", String(this.open));

		if (this.open) {
			$(this.contentEl).slideDown();
			this.buttonEl.parentElement?.classList.add('accordion-expanded'); // 👉 aggiunge la classe al padre
		} else {
			$(this.contentEl).slideUp();
			this.buttonEl.parentElement?.classList.remove('accordion-expanded'); // 👉 rimuove la classe se chiuso
		}
	}


}
